import { useEffect, useState } from "react";
import TypographyToggle from "./TypographyToggle";
import LayoutInspector from "./LayoutInspector";

function shouldEnable(): boolean {
  if (import.meta.env.DEV) return true;
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  if (params.has("typo-debug") || params.has("layout-debug") || params.has("dev-tools")) return true;
  return localStorage.getItem("devToolsEnabled") === "1";
}

export default function DevToolsPanel() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setEnabled(shouldEnable());
    const params = new URLSearchParams(window.location.search);
    if (params.has("dev-tools")) localStorage.setItem("devToolsEnabled", "1");
  }, []);

  if (!enabled) return null;

  return (
    <div
      data-dev-panel
      className="fixed bottom-4 right-4 z-[9999] flex flex-col items-end gap-2 print:hidden"
    >
      <LayoutInspector />
      <TypographyToggle />
    </div>
  );
}
